/**
 * @desc mm100 页面 activityId 映射关系
 */

export enum ActivityIdMap {
    us = '3',
    eu = '5',
    ca = '4',
    au = '11',
    uk = '6',
    kr = '10',
    de = '7',
    fr = '8',
    jp = '9',
    cn = '12',
    za = '13',
    'sa' = '14',
    it = '54',
    es = '53',
}

export type KeyType = keyof typeof ActivityIdMap;
